export type HorseType = 'YEARLING' | 'YEAR2' | 'CAE' | 'MARE' | 'MAIDEN' | 'STORE2' | 'STORE3' | 'STALLION' | 'STALLION_PROSPECT' | 'STALLION_PART' | 'PROTRUSION' | 'FOAL' | 'BREEDING_RIGHT'

const horseTypes: { value: HorseType, text: string, trot: boolean }[] = [
  { value: 'YEARLING', text: 'Yearling', trot: true },
  { value: 'YEAR2', text: '2 ans', trot: false },
  { value: 'CAE', text: 'CAE', trot: true },
  { value: 'MARE', text: 'Jument', trot: true },
  { value: 'MAIDEN', text: 'Maiden', trot: true },
  { value: 'STORE2', text: 'Store 2', trot: false },
  { value: 'STORE3', text: 'Store 3', trot: false },
  { value: 'STALLION', text: 'Étalon', trot: true },
  { value: 'STALLION_PROSPECT', text: 'Prospect', trot: true },
  { value: 'PROTRUSION', text: 'Saillie', trot: true },
  { value: 'STALLION_PART', text: 'Part d\'étalon', trot: true },
  { value: 'FOAL', text: 'Foal', trot: true },
  { value: 'BREEDING_RIGHT', text: 'Breeding right', trot: true },
]

const horseTypeObject = {} as Record<HorseType, string>
horseTypes.forEach((e) => {
  horseTypeObject[e.value] = e.text
})

export function getHorseTypeLabel(key?: HorseType): string | undefined {
  return key && horseTypeObject[key]
}

export const horseTypesGalop = horseTypes.sort((op1, op2) => op1.value.localeCompare(op2.value))
export const horseTypesTrot = horseTypes.filter(el => el.trot).sort((op1, op2) => op1.value.localeCompare(op2.value))
